import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { downloads } from 'src/app/pages/util/calsoft-validators';
import { ProductService } from 'src/app/services/product.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserCourseHistoryService } from 'src/app/services/user-course-history.service';
import { Constant } from 'src/app/constants/constant';
import { Clipboard } from '@angular/cdk/clipboard';
import { interval, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CourseRatingComponent } from '../course-rating/course-rating.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Location } from '@angular/common';
import { RatingOptionVote, Review, ReviewDetail } from 'src/app/models/review';
import { ActivatedRoute } from '@angular/router';
import { ReviewRatingService } from 'src/app/services/review-rating.service';
import { NotesService } from 'src/app/services/notes.service';
import { NotesComponent } from '../notes/notes.component';

@Component({
  selector: 'calsoft-course-detail-mob',
  templateUrl: './course-detail-mob.component.html',
  styleUrls: ['./course-detail-mob.component.scss']
})
export class CourseDetailMobComponent implements OnInit, AfterViewChecked, OnDestroy{
  @Input() product: any;
  @Input() courseText: any = [];
  videocontent: any;
  activeIndex: number = 0;
  videolist: any = [];
  type: any;
  value: any;
  title: any;
  primaryIndex: number;
  secondaryIndex: number;
  init: boolean = false;
  initCourseCertificate:boolean = false;
  @Input() shortDescription: any;

  @Input() description: any;
  @Input() productDetailHeightMobile: any;
  @Input() productDetailWidthMobile: any;
  @Input() productDetailHeight: any;
  @Input() productDetailWidth: any;
  @Input() productDetailPage: any;

  @Input() data: any;

  @Input() name: any;

  @Input() response: any;

  @Input() reviewDetail: any

  @Input() relatedProductsList: any;

  @Input() upSellsProductsList: any;

  @Input() crossSellsProductsList: any

  @Input() recentlyViewedProducts: any;
  @Input() certificateEnablePercentage;
  @Input() displayColdChain: boolean;
  @Input() deliveryDoorStepIcon: any;
  @Input() showTimeIcon: any;
  @Input() showGenuineProductIcon: any;
  @Input() genuineProductText: any;
  @Input() deliveryTime: any;
  @Input() deliveryDoorStepText: any;
  @Input() ColdChain: any;
  @Input() guestLogin: any;
  @Input() videourl: any;
  @Input() videoAvaliable: boolean;
  @Input() isInStock: any;
  @Input() qty: any;
  @Input() manageStock: any;
  @Input() factBox: any;
  @Input() faq: any;
  @Input() SIDEEFFECTS: any;
  @Input() Commonsideeffects: any;
  @Input() SafetyAdvice: any;
  @Input() HOWTOUSE: any;
  @Input() UsesOf: any;
  @Input() Benefits: any;
  @Input() HowWorks: any;
  @Input() Ifmiss: any;
  @Input() productName: any;
  @Input() PregnancyInteraction: any;
  @Input() BreastfeedingInteraction: any;
  @Input() DrivingInteraction: any;
  @Input() KidneyInteraction: any;
  @Input() LiverInteraction: any;
  @Input() MANUFACTURER: any;
  @Input() SALTCOMPOSITION: any;
  @Input() STORAGES: any;
  @Input() factbox: any;
  @Input() spec: any;
  @Input() showNewConfig: boolean = false;
  @Input() units: any;
  @Input() discountPercentage: any;
  @Input() price: number;
  @Input() specialPrice: any;
  @Input() averageRating: any;
  @Input() calculateAvgRating: any
  @Input() prescriptionRequired: boolean = false;
  @Input() imageList: any;
  @Input() productDetailImageWidth: any;
  @Input() productzoom: any;
  @Input() productIdAddedInCart: any = {};
  @Input() configattributeType: any;
  @Input() firstIndex: any;
  @Input() secondIndex: any;
  @Input() configurationDropDownList = new Map<any, any>();
  @Input() dropDownValue = new UntypedFormControl('');
  @Input() configProductSelected: any;
  @Input() configProduct: any;
  @Input() showExclusivePrice: number;
  @Input() managePriceSeperately: number;
  @Input() maintainStockIndConfProduct: number;
  @Input() manageAdditionalInformationSeperately: number;
  @Input() manageDescriptionSeperately: number;
  @Input() manageNameSeperately: number;
  @Input() manageImageSeperately: number;
  @Input() bigImage: string;
  @Input() alcoholInteraction: any;
  @Input() commonImageApi: any;
  @Input() relatedProductsText: any;
  @Input() upSellProductsText: any;
  @Input() crossSellProductsText: any;
  @Input() recentlyViewedProductsText: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() categoryArray: any;
  @Input() indexConfig: any = 0;
  @Input() productImageWidth: any;
  @Input() productImageType: any;
  @Input() productImageWidthMob: any;
  @Input() productImageHeightMob: any;
  @Input() productImageHeight: any;
  @Input() showConfigurableDropdown: any;
  @Input() coversionTrackingIdGa: any;
  enableEnquire: any = 0;
  disablePriceInDetailPage: any = 1;
  @Input() MapLink: any;
  @Input() speechArray: any;
  @Input() order: any;
  @Input() buttonArray: any = [];

  @Input() CourceDescription: any;

  @Input() CourseIncludes: any;

  @Input() Language: any;

  @Input() LastUpdated: any;

  @Input() Lecture: any;

  btndownload:string='Get a Certificate';

  public youtubeUrl = environment.youtubeUrl;


  isExpanded: boolean = false;
  initShortDescription: boolean = false;
  sendCourseHistory: boolean = true;
  productId: any;
  courseHistory: Object;
  initCourse: boolean = false;
  lastViewedTime: any = 0;
  courseDuration: any = 0;
  courseCompletedPercentage: any;
  courseCompletedSection: any;
  countdown: number;
  countdownMapping: any;

  courseHistorySeconds: any = 20;
  totalCourseItem: any;
  index: any = 0;
  certificateType: any;
  producImageWidth: any;
  newCourse: boolean=false;
  noteList: any=[];
  displayCourse: boolean;
  categoryPageProductNameDisplayLineMobHeight =2;
  categoryPageProductNameDisplayLine = 2;

  constructor(
  
    private activatedRoute: ActivatedRoute,
    private reviewService: ReviewRatingService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private configService: ConfigServiceService,
    private productService: ProductService,
    private userCourseHistoryService: UserCourseHistoryService,
    private location: Location,
    private notesService : NotesService
  ) {

    // Set the private default
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.countdown = this.courseHistorySeconds;
    this.countdownMapping = {
      '=1': '# second',
      'other': '# seconds'
    };

  }

  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIfMobile();
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 600;
  }
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          this.certificateEnablePercentage = data['certificateEnablePercentage'];
          this.certificateType= data['certificateType'];
          this.productImageHeight =data['productImageHeight'];
          this.producImageWidth =data['producImageWidth'];
          this.productImageHeight =data['productImageHeight'];
          this.producImageWidth =data['producImageWidth'];
          this.productDetailHeightMobile = data['productMImageHeight'];
          this.productDetailWidthMobile = data['productMImageWidth'];

          this.courseHistorySeconds =data['courseHistorySeconds'];
          this.categoryPageProductNameDisplayLine=data['categoryPageProductNameDisplayLine']
          this.categoryPageProductNameDisplayLineMobHeight=data['categoryPageProductNameDisplayLineMobHeight']

        }, error => {

        }
      );
  }
  h2c: any = html2canvas;

  @ViewChild('htmlData') htmlData!: ElementRef;

  generate() {
    this.btndownload = 'Downloading ...';
    this.initCourseCertificate = true;

    // Use a timeout to allow Angular to render the components
    setTimeout(() => {
      const DATA = this.htmlData.nativeElement;
      if (DATA) {
        DATA.style.display = 'block';

        // Convert dimensions from inches to millimeters
        const certificateWidth = 279.4; // 11 inches in mm
        const certificateHeight = 215.9; // 8.5 inches in mm

        html2canvas(DATA, {
          allowTaint: true,
          useCORS: true
        }).then((canvas) => {
          // Get canvas dimensions
          let canvasWidth = canvas.width;
          let canvasHeight = canvas.height;

          // Adjust the canvas dimensions to fit the certificate size
          let fileWidth = certificateWidth;
          let fileHeight = (canvasHeight * certificateWidth) / canvasWidth;

          const FILEURI = canvas.toDataURL('image/png');
          let PDF = new jsPDF('landscape', 'mm', [certificateWidth, certificateHeight]);
          let position = 0;

          PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);

          let name = 'certificate' + '.pdf';
          PDF.save(name);

          // Reset the states after the PDF generation is complete
          DATA.style.display = 'none';
          this.btndownload = 'Get a Certificate';
          this.initCourseCertificate = false;
        });
      } else {
        console.error('htmlData element is not found');
      }
    }, 100); // Adjust the timeout as needed
  }

  isReviewRatingVisible = false;

  toggleReviewRating() {
    this.isReviewRatingVisible = !this.isReviewRatingVisible;
  }


  page1: any;
  checkevent(event : boolean){
    if(event == true){
      this.isReviewRatingVisible = false;
    }
  }
  reviewPopup() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CourseRatingComponent, {
        width: '790px',
        disableClose: false,
        data: { productId: this.productId }
      });


      dialogRef.disableClose = false;

    }
    else {
      let dialogRef = this.dialog.open(CourseRatingComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: false,
        data: { productId: this.productId }
      });

      dialogRef.disableClose = false;
    }

  }
  toggleFlex() {
    this.isExpanded = !this.isExpanded;
  }


  ngOnChanges() {

    if (window.innerWidth < 1281) {
      this.displayCourse = false;
    }else{
      this.displayCourse=true
    }

    if (this.product != null) {

      this.courseText = JSON.parse(this.product['courseText'])

    }
  }

  public serverPath = environment.commonImageApi + '/courseVideo/';

  public serverPath1 = environment.commonImageApi + '/courseImage/';

  public serverPath2 = environment.commonImageApi + '/courseAudio/';

  downloadPdf(name) {
    if (name != undefined) {
      let smallImage = "/coursepdf/" + name;
      this.productService.downloadPdf(smallImage).subscribe(
        data => {
          downloads(data, name);
        },
      )
    }
  }

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  currentVideoUrl = '';
  activeIndexx = '';
  currentVideoIndex = 0;

  onTimeUpdate(event: any) {

    const currentTime = this.videoPlayer.nativeElement.currentTime;
    const seconds = Math.floor(currentTime);
    let courseDuration = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].courseDuration;
    if (courseDuration <= seconds) {
  
      if ((this.sendCourseHistory && seconds > 10) || courseDuration == seconds) {


        this.countdown = this.courseHistorySeconds;
        this.sendCourseHistory = false;
        this.setCourseHistory(seconds, 3);


      }
    }
    


  }
  url;
  showInfo = false;
  toggleInfo() {
    this.showInfo = !this.showInfo;
    this.showInfo1 = false;
  }
  showInfo1 = false;
  toggleInfo1() {
    this.showInfo1 = !this.showInfo1;
    this.showInfo = false;
  }
  copy() {
    let currentURL = window.location.href;
    // this.url = currentURL;
    this.clipboard.copy(`${currentURL}`);
    this.snackBar.open(`Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
  }

  setCourseHistory(seconds, index) {
    this.sendCourseHistory = false;
    let courseItemId = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].courseItemId

    let courseId = this.courseText[this.primaryIndex].courseId;

    let courseDuration = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].courseDuration;

    let courseType = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].type;

    let object = {

      "courseDuration": courseDuration,
      "courseSpendTime": seconds,
      "courseItemLastViewedTime": seconds,
      "courseItemId": courseItemId,
      "courseId": courseId,
      "productId": this.productId,
      "type": courseType
    }


    if (this.type == 1 || this.type == 8) {


      if(this.newCourse){
        this.newCourse=false;
        this.setCourseItem(object)
      }
      else if ((seconds > this.lastViewedTime)) {
        if (object.courseItemLastViewedTime > 0) {
        this.setCourseItem(object)

        }else{
          this.sendCourseHistory = true;
        }
      

      }
    } else {
      this.setCourseItem(object)
    }

    


   


  }

  setCourseItem(object: any) {

   
      this.userCourseHistoryService.courseHistory(object).subscribe(
        (response) => {
          console.log(response);

          if (this.index == 0) {

            this.initialized = false;
          } else {
            this.initialized = true;
          }


          this.index = this.index + 1;

          this.courseCompletedPercentage = response['data']['courseCompletedPercentage'];

          this.courseCompletedSection = response['data']['totalCompletedSection'];



          if (this.courseHistory != null) {



            let courseItemIdIndex = this.courseHistory['userCourseItemHistory'].findIndex(courseItem => courseItem.courseItemId == response['data']['courseLastViewedSection']);

            if (courseItemIdIndex > -1) {
              this.courseHistory['userCourseItemHistory'][courseItemIdIndex] = response['data']['userCourseItemHistory'][0]
            }

          } else {

            this.courseHistory = response['data'];
          }
          const duration = this.countdown;
          // setTimeout(() => {
          //   this.sendCourseHistory = true;
          // }, 60000);

          // Redirect after the countdown
          interval(1000)
            .pipe(
              take(duration),
              takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {

              // console.log(this.countdown);

              if (this.countdown > 0) {
                this.countdown--;
              }

            },
              () => {
              },
              () => {
                this.sendCourseHistory = true;
              }
            );



        },
        (err) => {
          console.log(err);
        });
   
  }

  playInitialVideo() {
    this.currentVideoIndex = 0;
    this.changeVideo(this.videolist[this.currentVideoIndex].value, this.videolist[this.currentVideoIndex].title);
  }

  changeVideo(url: string, title: string) {
    this.currentVideoUrl = url;
    this.activeIndexx = title;

    this.videoPlayer.nativeElement.load(); // This reloads the video element with the new source

  }

  onVideoEnded(): void {

    let length = this.courseText[this.primaryIndex].courseItem.length;

    if (length - 1 == this.secondaryIndex) {

      this.getVideoData(this.courseText[this.primaryIndex + 1].courseItem[0], this.primaryIndex, 0, 1)

    } else {
      this.getVideoData(this.courseText[this.primaryIndex].courseItem[this.secondaryIndex + 1], this.primaryIndex, this.secondaryIndex + 1, 1)
    }

  }

  accordionOpenIndex: number | null = 0;
  subaccordionOpenIndex: { [key: number]: number | null } = {};

  toggleAccordion(index: number) {
    if (this.accordionOpenIndex === index) {
      this.accordionOpenIndex = null; // Collapse if already open
    } else {
      this.accordionOpenIndex = index; // Expand clicked section
    }
  }

  subtoggleAccordion(parentIndex: number, subIndex: number) {
    if (this.subaccordionOpenIndex[parentIndex] === undefined) {
      this.subaccordionOpenIndex[parentIndex] = null;
    }
    this.subaccordionOpenIndex[parentIndex] = this.subaccordionOpenIndex[parentIndex] === subIndex ? null : subIndex;
  }


  getVideoData(subsection, i, j, firstInit) {

  
      this.newCourse=false;
      if (subsection != undefined) {
        this.type = subsection.type;
  
        this.value = subsection.value;
  
        this.title = subsection.title;
  
     
        this.primaryIndex = i;
        this.secondaryIndex = j;
  
        if (this.type == 1 || this.type == 8 && firstInit > 0) {
  
          let lastViewedCourseItemId = subsection['courseItemId'];

          if(this.courseHistory!=null){
            let courseItemIdHistoryIndex = this.courseHistory['userCourseItemHistory'].findIndex(courseHistory => courseHistory.courseItemId == lastViewedCourseItemId);
  
            if (courseItemIdHistoryIndex > -1) {
              this.lastViewedTime = this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].courseItemLastViewedTime;
    
              this.courseDuration = this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].courseDuration
            }
    
          }
     
  
          if (this.courseDuration == this.lastViewedTime) {
  
            this.lastViewedTime = 0;
          }
  
          if (this.lastViewedTime > 0) {
            this.videoPlayer.nativeElement.currentTime = this.lastViewedTime;
          }
  
  
          this.videoPlayer.nativeElement.load();
        }

        if(this.primaryIndex!=i){
          this.newCourse=true;
          this.setCourseHistory(0, firstInit);
        }
    
       else if(this.secondIndex!=j){
    
          this.newCourse=true;
          this.setCourseHistory(0, firstInit);
          
        }
  
  
        if (firstInit > 0) {
          if (this.type != 1 || this.type != 8) {
  
            this.setCourseHistory(0, firstInit);
          }
  
        }
  
      }
      
    





  }

  closeExpanded() {
    this.isExpanded = false;
  }
  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showInfo = false;
    }
  }
  callright(event : boolean){
    if(event == true){
      this.moveRight();
    }
  }
  moveRight(): void {

    let length = this.courseText[this.primaryIndex].courseItem.length;

    if (length - 1 == this.secondaryIndex) {

      this.accordionOpenIndex=this.primaryIndex + 1;
      this.getVideoData(this.courseText[this.primaryIndex + 1].courseItem[0], this.accordionOpenIndex, 0, 1)

    } else {
      this.getVideoData(this.courseText[this.primaryIndex].courseItem[this.secondaryIndex + 1], this.primaryIndex, this.secondaryIndex + 1, 1)
    }

  }


  moveLeft(): void {
    if (this.secondaryIndex === 0) {
      if (this.primaryIndex > 0) {
        let prevLength = this.courseText[this.primaryIndex - 1].courseItem.length;
        this.accordionOpenIndex=this.primaryIndex - 1;
        this.getVideoData(this.courseText[this.primaryIndex - 1].courseItem[prevLength - 1], this.primaryIndex - 1, prevLength - 1, 1);
      }
    } else {
      this.getVideoData(this.courseText[this.primaryIndex].courseItem[this.secondaryIndex - 1], this.primaryIndex, this.secondaryIndex - 1, 1);
    }
  }


  getCourseHistory() {

    this.userCourseHistoryService.getCourseHistoryByProductId(this.productId==undefined?this.product.entityId:this.productId).subscribe(
      (response) => {
        // console.log(response);

        this.courseHistory = response;

        if (this.courseHistory != null) {

          let lastViewedCourseId = this.courseHistory['courseLastViewedCourse'];

          let lastViewedCourseItemId = this.courseHistory['courseLastViewedSection'];

          let courseIdIndex = this.courseText.findIndex(course => course.courseId == lastViewedCourseId);

          let courseItemIdIndex = this.courseText[courseIdIndex].courseItem.findIndex(courseItem => courseItem.courseItemId == lastViewedCourseItemId);

          if (courseIdIndex > -1 && courseItemIdIndex > -1) {
            this.primaryIndex = courseIdIndex;
            this.secondaryIndex = courseItemIdIndex;

            this.accordionOpenIndex=this.primaryIndex;

            this.courseCompletedPercentage = this.courseHistory['courseCompletedPercentage'];

            this.courseCompletedSection = this.courseHistory['totalCompletedSection'];

            // let courseIdHistoryIndex = this.courseHistory['userCourseItemHistory'].findIndex(courseHistory => courseHistory.courseId == lastViewedCourseId);

            let courseItemIdHistoryIndex = this.courseHistory['userCourseItemHistory'].findIndex(courseHistory => courseHistory.courseItemId == lastViewedCourseItemId);

            if (courseItemIdHistoryIndex > -1 &&
              (this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].type == 1
                || this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].type == 8)) {
              this.lastViewedTime = this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].courseItemLastViewedTime;

              this.courseDuration = this.courseHistory['userCourseItemHistory'][courseItemIdHistoryIndex].courseDuration

              if (this.courseDuration == this.lastViewedTime) {

                this.lastViewedTime = 0;
              }
            }

          }
          else {


            this.primaryIndex = 0;
            this.secondaryIndex = 0;

            this.courseCompletedPercentage = 0;

            this.courseCompletedSection = 0;

          }



        } else {

          this.primaryIndex = 0;
          this.secondaryIndex = 0;

          this.courseCompletedPercentage = 0;

          this.courseCompletedSection = 0;
        }

        this.courseText = JSON.parse(this.product['courseText'])

        this.totalCourseItem = this.product.totalCourseItem;
        this.initCourse = true;

        this.type = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].type;


        this.getVideoData(this.courseText[this.primaryIndex].courseItem[this.secondaryIndex], this.primaryIndex, this.secondaryIndex, 0);
        // console.log(this.courseText)
        this.initCourse = true;



      },
      (err) => {
        console.log(err);
      });
  }
  private initialized: boolean = false;
  ngAfterViewChecked() {
    // Ensure videoPlayer is defined before accessing it
    if (this.type === 1 && !this.initialized) {
      this.initialized = true;
      if (this.videoPlayer && this.videoPlayer.nativeElement) {

        if (this.lastViewedTime > 0) {
          this.videoPlayer.nativeElement.currentTime = this.lastViewedTime;

        }

      }
    }
  }


  // Private
  private _unsubscribeAll: Subject<any>;

  /**
 * On destroy
 */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  updateCompletionPercentage() {
    this.courseCompletedPercentage = (this.courseCompletedSection / this.totalCourseItem) * 100;
  }

  back() {
    this.location.back();
  }
  @Output() closePopupEvent = new EventEmitter<void>();
  approval: any;
  firstFormGroup: UntypedFormGroup;
  requiredRatingVisible: boolean;
  text: string;
  inputs: any;

  id: any;
  subProductId: any;
 

  @Input() Displaytype: any = 1;
  



  ngOnInit() {
    this.checkIfMobile();
    this.url = window.location.href;
    this.updateCompletionPercentage();

    this.productId = this.product.entityId;

    this.getLeadNote(this.productId);

    this.getCourseHistory();
    if (this.shortDescription != undefined) {

      if (this.shortDescription.length > 0) {
        this.shortDescription = this.shortDescription.replace(/<ul>/g, '')
          .replace(/<\/?li>/g, '')
          .replace(/<\/?p>/g, '')
          .replace(/<br>/g, '');

      }

      this.initShortDescription = true;


      // console.log(this.shortDescription);
    } else {
      this.initShortDescription = false;
    }

    this.getConfigData();
    this.reviewForm();
 
    this.type=this.activatedRoute.snapshot.params['type'];

    if( this.type=='Variants'){
      this.subProductId=this.activatedRoute.snapshot.params['subProductId'];
    }else{
      this.subProductId=1;
    }
    this.requiredRatingVisible = false;
    this.text = 'SUBMIT'

    // if(this.Displaytype!=2){
    //   this.productId = this.activatedRoute.snapshot.params['productId'];
    // }
   
   
    this.getReviewById();
    
  
    
  }

  cancel() {
    this.location.back();
  }
  closePopup() {
    this.dialog.closeAll();
  }

  getReviewById() {
    let productId = this.productId;
    if(this.type!='Variants'){
      this.reviewService.getReviewById(productId).subscribe(
        (response) => {
          if (response['data'] != null) {
            this.id=response['data']['reviewId'];
          //  this.editReview(response['data']);
            this.approval = response['data']['statusId']
          }
          else {
            this.id=0;
          }
        },
        error => {
        }
      )
    }else{
      this.reviewService.getReviewByIdSubId(productId,this.subProductId).subscribe(
        (response) => {
          if (response['data'] != null) {
            this.id=response['data']['reviewId'];
            this.editReview(response['data']);
            this.approval = response['data']['statusId']
          }
          else {
            this.id=0;
          }
        },
        error => {
        }
      )
    }

  }

  reviewForm() {
    this.firstFormGroup = this.formBuilder.group({
      reviewDetail: this.formBuilder.group({
        detailId: ['',],
        storeId: new UntypedFormControl(1),
        title: ['', [Validators.required, ]],
        detail: ['', [Validators.required, ]],
        nickname: ['',],
        customerId: ['',],
      }),
      reviewId: ['',],
      createdDate: ['',],
      entityId: new UntypedFormControl(1),
      entityPkValue: ['',],
      entityPkChildValue:[''],
      statusId: new UntypedFormControl(2),
      ratingOptionVote: this.formBuilder.array([
        this.ratingOptionVoteForm()
      ])
    })
  }


  ratingOptionVoteForm() {
    return this.formBuilder.group({
      voteId: [''],
      optionId: [''],
      remoteIp: [''],
      remoteIpLong: [''],
      customerId: [''],
      entityPkValue: [''],
      percent: [''],
      value: ['', Validators.required],
      ratingId: ['']

    });

  }
  editReview(review: Review) {
    this.firstFormGroup.patchValue({
      reviewId: review.reviewId,
      createdDate: review.createdDate,
      entityId: review.entityId,
      entityPkValue: review.entityPkValue,
      statusId: review.statusId,
      entityPkChildValue:review.entityPkChildValue
    });
    this.editReviewDetail(review.reviewDetail)
    this.firstFormGroup.setControl('ratingOptionVote', this.editAddress(review.ratingOptionVote));
  }
  editReviewDetail(reviewDetail: ReviewDetail) {
    reviewDetail = {
      detailId: reviewDetail.detailId,
      storeId: reviewDetail.storeId,
      title: reviewDetail.title,
      detail: reviewDetail.detail,
      nickname: reviewDetail.nickname,
      customerId: reviewDetail.customerId

    };
    this.firstFormGroup.get('reviewDetail').patchValue(reviewDetail)
  }

  editAddress(ratingOptionVote: RatingOptionVote[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    ratingOptionVote.forEach(s => {
      formArray.push(this.formBuilder.group({
        voteId: s.voteId,
        optionId: s.optionId,
        remoteIp: s.remoteIp,
        remoteIpLong: s.remoteIpLong,
        customerId: s.customerId,
        entityPkValue: s.entityPkValue,
        percent: s.percent,
        value: s.value,
        ratingId: s.ratingId,

      }));
    });
    return formArray;
  }


  getRatingData(event) {
    this.firstFormGroup.value.ratingOptionVote[0].optionId = event.count;
    this.firstFormGroup.value.ratingOptionVote[0].value = event.count;
    this.firstFormGroup.value.ratingOptionVote[0].percent = event.ratingPercent;
    this.firstFormGroup.value.ratingOptionVote[0].ratingId = 1;
    this.firstFormGroup.value.ratingOptionVote[0].customerId = event.customerId;
    this.firstFormGroup.value.ratingOptionVote[0].entityPkValue = this.productId;
    // this.firstFormGroup.controls.ratingOptionVote['controls'][0]['controls'].value['errors'].required  = false;
    // this.firstFormGroup.controls.ratingOptionVote['controls'][0]['controls'].value['status'] = "VALID";
    this.firstFormGroup.patchValue(this.firstFormGroup.value)

  }


  booleanField: any = [
    { "value": 1, "viewValue": "Approved" },
    { "value": 2, "viewValue": "Pending" },
    { "value": 3, "viewValue": "Not Approved" },
  ]


  createReview() {
    this.requiredRatingVisible = true;
    //this.firstFormGroup.value.dob = "2019-06-23 11:23:23"
    this.firstFormGroup.value.statusId = 2;
    this.firstFormGroup.value.entityId = 1;
    this.firstFormGroup.value.storeId = 1;
    this.firstFormGroup.value.entityPkChildValue = this.subProductId;
    this.firstFormGroup.value.operationType = "CHANGE";
    this.firstFormGroup.value.entityPkValue = this.productId;
    this.firstFormGroup.value.reviewDetail.customerId = 0;
    if (this.text == 'SUBMIT' && this.firstFormGroup.valid) {
      this.text = "Processing"
      this.firstFormGroup.value.operationType = "CHANGE";

      if(this.Displaytype!=2){
        this.firstFormGroup.value.entityPkValue = this.route.snapshot.params['productId'];
      }
    
      this.reviewService.createReview(this.firstFormGroup.value).subscribe(
        response => {
          //   this.router.navigate(['/users']);
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open("Review Submitted Successfully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            if(this.Displaytype==1){
              this.location.back();
            }
            
          }
          else {
            this.text = "Processing"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        }, error => {
          this.text = "Processing"
        }
      );
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  validation = {

    'title': [
      { type: 'required', message: 'Please fill out this field.' },
    ],
    'detail': [
      { type: 'required', message: 'Please fill out this field.' },

    ]

  }


  createNote(note:any,noteId:any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(NotesComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "productId": this.product.entityId,
          "note":note,
          "noteId":noteId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.product.entityId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(NotesComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
           "productId": this.product.entityId,
           "note":note,
           "noteId":noteId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
           this.getLeadNote(this.product.entityId);
        }

      });
    }
  }

  getLeadNote(productId) {

    this.notesService.getAllNoteByLeadId(productId).subscribe(
      res => {
        this.noteList = res;
      },
      error => {

      }
    )
  }

}

